import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { getSlackConnectionStatus } from '../query';

export function useGetSlackConnectionStatus(
  userId: string | null | undefined,
): UseQueryResult<boolean, Error> {
  return useQuery({
    queryKey: ['slackConnectionStatus', userId],
    queryFn: () => {
      if (!userId) throw new Error('User ID is required');
      return getSlackConnectionStatus(userId);
    },
    enabled: !!userId,
  });
}
